module.exports = __webpack_public_path__ + "static/2-1cc111bebd870eb84ec75e9ba2ac252c.jpg";